'use strict';

var showMarkingDescription = require('./showMarkingDescription');
var carouselHelper = require('core/components/carousel');

/**
 * Updates the recommendation carousal in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateSafetyRecommendations(response) {
    var $recommendations = $(document).find('.recommendations-carousel');
    $recommendations.html(response.product.relatedRecommendations);
    if (response.product.relatedRecommendations) {
        $recommendations.removeClass('slick-initialized slick-slider');
        carouselHelper.methods.initRecommendationsCarousel($recommendations);
        $(document).find('.recommendations .product-reco').removeClass('d-none');
        $(document).find('.recommendations .product-reco').attr('aria-hidden', 'false');
    } else {
        $(document).find('.recommendations .product-reco').addClass('d-none');
        $(document).find('.recommendations .product-reco').attr('aria-hidden', 'true');
    }
}

/**
 * Updates the product attribute in the Product Detail Page
 *
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} attrValue - Attribute value for the passed attrbute id
 * @param {string} className - Attribute class name to be changed
 */
function updateAttribute($productContainer, attrValue, className) {
    var $container = $productContainer.find(className);
    if (attrValue && attrValue.length > 0) {
        $container.find(className + '-value').html(attrValue);
        $container.removeClass('d-none');
    } else {
        $container.find(className + '-value').empty();
        $container.addClass('d-none');
    }
}

function updateMarkingAttributes($productContainer, attribute, type) {
    var markingValues = '';
    var markingDescriptions = '';
    $productContainer.find('.' + type + '-markings-list-description').addClass('d-none');
    attribute.forEach(function (marking, index) {
        if (index === 0) {
            markingValues += '<div data-value="' + marking.id + '" class="col-4 col-md-2 ' + type + '-column first-' + type + '-marking"><div class="' + type + '-markings-list-column">' + marking.value + '</div></div>';
        } else {
            markingValues += '<div data-value="' + marking.id + '" class="col-4 col-md-2 ' + type + '-column"><div class="' + type + '-markings-list-column">' + marking.value + '</div></div>';
        }
        markingDescriptions += '<div id="' + marking.id + '" class="col-12 text-left ' + type + '-markings-list-description d-none">' + marking.description + '</div>';
    });
    var className = '.' + type + '-markings-list';
    $productContainer.find(className).html(markingValues + markingDescriptions);
}

/**
 * Updates the product attributes related to Bolle Safety in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttributes(response, $productContainer) {
    if (!response.product.price.sales || response.product.price.sales.value == null) {
        $('.tax-inclusive-section').removeClass('d-block').addClass('d-none');
    } else {
        $('.tax-inclusive-section').removeClass('d-none').addClass('d-block');
    }

    $productContainer.find('.lens-attributes').removeClass('d-none');
    $productContainer.find('.product-name').html(response.product.productName);

    updateAttribute($productContainer, response.product.subtitleDescription, '.product-subtitle-description');
    updateAttribute($productContainer, response.product.marketingDescription, '.marketing-description');
    updateAttribute($productContainer, response.product.keySellingPoint1, '.selling-point-1');
    updateAttribute($productContainer, response.product.keySellingPoint2, '.selling-point-2');
    updateAttribute($productContainer, response.product.keySellingPoint3, '.selling-point-3');
    updateAttribute($productContainer, response.product.keySellingPoint4, '.selling-point-4');
    updateAttribute($productContainer, response.product.lensDescriptionAsset, '.lens-description');
    updateAttribute($productContainer, response.product.productReinssurance, '.product-reinssurance');
    updateAttribute($productContainer, response.product.prescriptionLensAsset, '.prescription-lens');
    updateAttribute($productContainer, response.product.daiteoFrameShape, '.product-frame-shape');

    // In the case where a product has no selling point we hide the selling point container to remove
    // the black background.

    if (!response.product.keySellingPoint1
        && !response.product.keySellingPoint2
        && !response.product.keySellingPoint3
        && !response.product.keySellingPoint4) {
        $productContainer.find('.key-selling-point-container').hide();
    } else {
        $productContainer.find('.key-selling-point-container').show();
    }

    if (response.product.daiteoManufacturerSKU && response.product.daiteoManufacturerSKU.length > 0) {
        $productContainer.find('.manufacturer-sku').html(response.product.daiteoManufacturerSKU);
        $productContainer.find('.manufacturer-sku-section').removeClass('d-none');
    } else {
        $productContainer.find('.manufacturer-sku').empty();
        $productContainer.find('.manufacturer-sku-section').addClass('d-none');
    }

    if (response.product.pictogramAssets) {
        if (response.product.pictogramAssets.length > 0) {
            var pictogramAssets = '';
            response.product.pictogramAssets.forEach(function (value) {
                pictogramAssets += '<div class="col-2 col-md-2">' + value + '</div>';
            });
        }
        $productContainer.find('.marketing-picto-value').html(pictogramAssets);
    }
    if (response.product.isCoBranding) {
        $productContainer.find('.co-branding').show();
    } else {
        $productContainer.find('.co-branding').hide();
    }

    // INFORMATIONS TECHNIQUES

    updateAttribute($productContainer, response.product.daiteoWeight + ' ' + response.product.daiteoWeightUnit, '.product-weight');
    updateAttribute($productContainer, response.product.daiteoFrameBase, '.frame-base');
    updateAttribute($productContainer, response.product.daiteoFrameType, '.frame-type');
    updateAttribute($productContainer, response.product.daiteoFrameMaterial, '.frame-material');
    updateAttribute($productContainer, response.product.daiteoFrameColour, '.frame-colour');
    updateAttribute($productContainer, response.product.daiteoLensMaterial, '.lens-material');
    updateAttribute($productContainer, response.product.daiteoLensColour, '.lens-colour');
    updateAttribute($productContainer, response.product.daiteoLensCoating, '.lens-coating');
    updateAttribute($productContainer, response.product.daiteoTechnology, '.lens-technology');
    updateAttribute($productContainer, response.product.daiteoStrapMaterial, '.strap-material');
    updateAttribute($productContainer, response.product.daiteoBallisticResistance, '.ballistic-resistance');
    updateAttribute($productContainer, response.product.daiteoStandard, '.product-standard');
    updateAttribute($productContainer, response.product.daiteoAtexCertificate, '.product-atexcertificate');
    updateAttribute($productContainer, response.product.daiteoAtexAreaGroup, '.product-atexareagroup');
    updateAttribute($productContainer, response.product.daiteoSuppliedWith, '.supplied-with');
    updateAttribute($productContainer, response.product.daiteoLensDimensionsA, '.lens-dimensions-a');
    updateAttribute($productContainer, response.product.daiteoLensDimensionsB, '.lens-dimensions-b');
    updateAttribute($productContainer, response.product.daiteoBridgeDimension, '.bridge-dimension');
    updateAttribute($productContainer, response.product.daiteoTempleDimension, '.temple-dimension');
    updateAttribute($productContainer, response.product.daiteoLensMarking, '.lens-marking');
    updateAttribute($productContainer, response.product.daiteoFrameMarking, '.frame-marking');
    updateAttribute($productContainer, response.product.CSAStatus, '.csa-status');

    updateMarkingAttributes($productContainer, response.product.frameMarkings, 'frame');
    updateMarkingAttributes($productContainer, response.product.lensMarkings, 'lens');

    if (response.product.daiteoUnderstandMarkings) {
        $productContainer.find('.understand-markings').show();
    } else {
        $productContainer.find('.understand-markings').hide();
    }

    if (response.product.daiteoTechnicalSheetURL) {
        $productContainer.find('.technical-sheet-download-button').show();
        $productContainer.find('.technical-sheet-link').attr('href', response.product.daiteoTechnicalSheetURL);
    } else {
        $productContainer.find('.technical-sheet-download-button').hide();
    }
    showMarkingDescription();
    updateSafetyRecommendations(response);
}

module.exports = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        updateAttributes(response.data, response.container);
    });
};
